module.exports = __webpack_public_path__ + "img/package_leaders.a30d44d8.jpg";